module.exports = __webpack_public_path__ + "static/media/framer.73671136.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/framer.mp4
// module id = 361
// module chunks = 0